import { AlertPriority, AlertStatus } from "@watcherr/resources";

export type SimpleAlert = { uuid: string, priority: AlertPriority, status: AlertStatus }

export enum AlertReceivedMethodSource {
  PUSH = "PUSH",
  API = "API",
  WS = "WEBSOCKET"
}
